/*------------------------------------*\
    MODULES
\*------------------------------------*/

var debounce = require('debounce');
import smoothscroll from 'smoothscroll-polyfill';

/*------------------------------------*\
    CONTACT US MODULE
\*------------------------------------*/
class ContactUs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.scrollTo();
        window.onresize = debounce(self.scrollTo);
    }

    scrollTo() {
        let self = this;
        let scrollInto = self.elem.querySelector('#contactUs');
        let targetScroll = self.elem.querySelector('#contact-us');
        let navHeigth = 120;
        let targetOffset = self.getOffsetTop(targetScroll) - navHeigth;

        smoothscroll.polyfill();

        scrollInto.addEventListener('click', (e) => {
            if (window.innerWidth > 991) {
                e.preventDefault();
                window.scroll({
                    top: targetOffset,
                    left: 0,
                    behavior: 'smooth'
                });
            }

        })

    }

    getOffsetTop(elem) {

        // Set our distance placeholder
        var distance = 0;

        // Loop up the DOM
        if (elem.offsetParent) {
            do {
                distance += elem.offsetTop;
                elem = elem.offsetParent;
            } while (elem);
        }

        // Return our distance
        return distance < 0 ? 0 : distance;
    }
}

export default ContactUs;